import { render, staticRenderFns } from "./LogoXingSvg.vue?vue&type=template&id=9a48f380"
import script from "./LogoXingSvg.vue?vue&type=script&lang=js"
export * from "./LogoXingSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports